import {Button} from "@mui/material";
import {FiPlus} from "react-icons/fi";
import ListView from "../components/ListView/ListView";
import LoadingContent from "../components/ui/LoadingContent";
import Window from "../components/Window/Window";
import SearchBar from "../components/ui/SearchBar";
import {m2mTokenColumns} from "../constants/dataGridColumns";
import {m2mTokenSearchFields} from "../constants/searchFields";
import useApiRequest from "../hooks/useApiRequest";
import usePaginationSearch from "../hooks/usePaginationSearch";
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";

const M2MTokens = () => {
  const {loading, list} = useApiRequest({baseUrl: "/m2m-tokens", resource: "m2m_tokens"});
  const {can} = useAuthPermissions();

  const fetcher = useCallback(
    async (query) => {
      const {success, data} = await list({...query});
      if (!success) return null;

      return {data};
    },
    [list]
  );
  const {filters, applyFilters, resetFilters, dataGridProps} = usePaginationSearch({
    fetcher
  });
  const navigate = useNavigate();

  return (
    <Window
      title={"M2M Tokens"}
      topRightButtons={
        can(ACTIONS.WRITE, RESOURCES.M2M_TOKENS) && (
          <Button variant="contained" startIcon={<FiPlus />} onClick={() => navigate("/m2m-tokens-form")}>
            Nuevo M2M Token
          </Button>
        )
      }
    >
      {loading ? (
        <LoadingContent />
      ) : (
        <>
          <SearchBar
            fields={m2mTokenSearchFields}
            initialValues={filters}
            onSearch={applyFilters}
            onReset={resetFilters}
          />
          <ListView
            columns={m2mTokenColumns}
            getRowId={(row) => row.id}
            loading={loading}
            dataGridProps={dataGridProps}
            TopRigthButtons={
              can(ACTIONS.WRITE, RESOURCES.M2M_TOKENS) && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    navigate(`/m2m-tokens-form`);
                  }}
                >
                  Nuevo M2M Token
                </Button>
              )
            }
          />
        </>
      )}
    </Window>
  );
};

export default M2MTokens;
